<!-- Skip to main content link for accessibility -->
<a href="#main-content" class="skip-link">Skip to main content</a>

<!-- Main content wrapper with proper landmark -->
<main id="main-content" tabindex="-1">
  <router-outlet></router-outlet>
</main>

<app-loader></app-loader>